import { render, staticRenderFns } from "./Parametro.vue?vue&type=template&id=0fb74a8f&"
import script from "./Parametro.vue?vue&type=script&lang=js&"
export * from "./Parametro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports